import { LOGOS } from "../../lib/api";
import { ArrowRight, CheckCircle2 } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="home"
      className="relative overflow-hidden bg-[#F9F8F6] grain"
      data-testid="hero-section"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full bg-[#E07A5F]/10 blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-[#1B4332]/10 blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-24 lg:pt-24 lg:pb-32 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 fade-in">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#1B4332]/10 text-[#1B4332] text-xs font-semibold tracking-widest uppercase">
            <span className="w-1.5 h-1.5 rounded-full bg-[#E07A5F]" />
            Government Registered Trust • Est. 2009
          </div>

          <h1 className="font-serif-display mt-6 text-4xl sm:text-5xl lg:text-6xl text-[#1B4332] leading-[1.05] tracking-tight font-medium">
            Empowering Individuals with{" "}
            <span className="not-italic text-[#E07A5F]">Professional Skills</span>
          </h1>

          <p className="mt-6 text-base sm:text-lg text-[#5C6661] max-w-xl leading-relaxed">
            Education and Development Social Welfare Foundation provides quality
            computer education and professional skill development programs to
            shape tomorrow's workforce.
          </p>

          <div className="mt-8 flex flex-wrap gap-4">
            <a
              href="#courses"
              className="inline-flex items-center gap-2 bg-[#1B4332] text-white px-6 py-3 rounded-full text-sm font-semibold hover:bg-[#2D6A4F] transition-all hover:gap-3"
              data-testid="hero-explore-courses-btn"
            >
              Explore Courses <ArrowRight className="w-4 h-4" />
            </a>
            <a
              href="#verify"
              className="inline-flex items-center gap-2 border border-[#1B4332] text-[#1B4332] px-6 py-3 rounded-full text-sm font-semibold hover:bg-[#1B4332] hover:text-white transition-all"
              data-testid="hero-verify-certificate-btn"
            >
              Verify Certificate
            </a>
          </div>

          <div className="mt-10 flex flex-wrap gap-x-8 gap-y-3 text-sm text-[#222B26]">
            {["Govt. Recognised", "700++ Trained", "Placement Support"].map((t) => (
              <div key={t} className="flex items-center gap-2">
                <CheckCircle2 className="w-4 h-4 text-[#2D6A4F]" />
                <span className="font-medium">{t}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5 fade-in delay-200">
          <div className="relative">
            <div className="absolute -inset-4 bg-gradient-to-br from-[#E07A5F]/20 to-[#F4A261]/20 rounded-3xl blur-2xl" />
            <div className="relative bg-white rounded-3xl p-8 lg:p-10 border border-border shadow-xl">
              <img
                src={LOGOS.main}
                alt="EDSW Foundation Seal"
                className="w-48 h-48 mx-auto object-contain"
                data-testid="hero-main-logo"
              />
              <div className="mt-6 text-center">
                <div className="overline text-[#E07A5F]">Since 2009</div>
                <h3 className="font-serif-display text-2xl text-[#1B4332] mt-2">
                  Education and Development
                </h3>
                <p className="text-sm text-[#5C6661] mt-1">
                  Social Welfare Foundation
                </p>
              </div>
              <div className="mt-6 grid grid-cols-3 gap-4 pt-6 border-t border-border">
                <div className="text-center">
                  <div className="font-serif-display text-3xl text-[#1B4332]">700+</div>
                  <div className="text-xs text-muted-foreground">Students</div>
                </div>
                <div className="text-center border-x border-border">
                  <div className="font-serif-display text-3xl text-[#1B4332]">15+</div>
                  <div className="text-xs text-muted-foreground">Years</div>
                </div>
                <div className="text-center">
                  <div className="font-serif-display text-3xl text-[#1B4332]">7</div>
                  <div className="text-xs text-muted-foreground">Courses</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
